/**
 * Controller: SettingsTerminalsCreateModal
 */
angular.module('acme.view.application.settings.terminals.configurationModal.controllers', [
  'acme.common.service.validate',
  'acme.common.service.api',
  'acme.common.service.helpers'
])
.controller('SettingsTerminalsConfigurationModalController', [ '$scope', '$uibModalInstance', 'selectedRows', 'ApiService', 'ValidateService', 'HelpersService', function ($scope, $uibModalInstance, selectedRows, ApiService, ValidateService, HelpersService) {
    
    $scope.model = [];
    $scope.selected = { config: null };
    $scope.isSubmitted = false;
    $scope.terminals = selectedRows;
    $scope.configs = [];
    $scope.errors = {};
    $scope.isUnassigned = false;
    
    $scope.formatName = function (terminal) {
       return terminal.data.name || '(' + terminal.data.terminalId + ')' || '(' + terminal.data.id + ')';
    };
    $scope.init = function() {
      $scope.getConfigs();
    };

    $scope.getConfigs = function() {
      ApiService.pos.list(HelpersService.getPaginator()).then(function(response) {
        $scope.configs = $scope.processConfig(response.data.payload.list);
        $scope.configs.unshift({ name: 'ACME System Default', configId: null});
      }, function(){});
    };

    $scope.processConfig = function(list) {
      var r = [], i, ii;
      for (i=0, ii=list.length; i < ii; i++) {
        if (list[i].status && list[i].status.publishDate){
          r.push(list[i]);
        }
      }

      return r;
    };

    $scope.isNotEmpty = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.selected.config.configId } }
        ]);
      }

      return r;
    };

    $scope.done = function() {
      var test = [{ len: { value: $scope.selected.config.name } }];
      if (!$scope.selected.config) {
        $scope.cancel();
      }
      $scope.isSubmitted = true;
      if(ValidateService.validate(test)) {
        $scope.success();
      } else {
        $scope.errors = [{
          message: 'Please correct the errors below'
        }];
      }

    };

    $scope.success = function () {
      $scope.terminals.map(function (obj,idx) {
        if (obj.data.type === 'pos') {
          if ($scope.selected.config.configId === null &&
            $scope.selected.config.name === "ACME System Default") {
            $scope.model.push({
              terminalId: obj.data.id,
              configId: null
            });
          } else {
            $scope.model.push({
              terminalId: obj.data.id,
              configId: $scope.selected.config.configId
            });
          }
        }
      });
      $uibModalInstance.close($scope.model);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    
    $scope.init();

}]);